import { NavLink } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const NavigationWrapper = styled.div`
  position: fixed;
  z-index: 2;

  height: 100vh;
  width: 100%;

  background: #ffffff;

    /*  animation-name: ${fadeIn};
  animation-duration: 0.325s;
  animation-timing-function: ease-in;*/
`;

const Navigation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  padding: 32px;

  > span {
    margin-top: auto;
    font-size: 12px;
    align-self: flex-start;
    color: #9b9b9b;
  }
`;

const NavButton = styled(NavLink)`
  font-size: 16px;
  font-weight: 500;
  
  width: 100%;
  padding: 8px;
  
  text-decoration: none;

  :not(:last-child) {
    margin-bottom: 32px;
  }

  color: #333333;

  :visited {
    color: #333333;
  }
`;

export const Styled = {
  NavigationWrapper,
  NavButton,
  Navigation,
};
